import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["src", "alt"]


export default /*#__PURE__*/_defineComponent({
  __name: 'countryRisk',
  props: {
    riskTitle: {},
    riskShort: {},
    riskLong: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", null, _toDisplayString(_ctx.riskTitle), 1 /* TEXT */),
    _createElementVNode("td", null, [
      _createElementVNode("img", {
        src: _ctx.riskShort,
        alt: _ctx.riskTitle
      }, null, 8 /* PROPS */, _hoisted_1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("img", {
        src: _ctx.riskLong,
        alt: _ctx.riskTitle
      }, null, 8 /* PROPS */, _hoisted_2)
    ])
  ]))
}
}

})